import React from "react";
import { useSelector, useDispatch } from "react-redux";
// Chakra imports
import { Flex, useColorModeValue } from "@chakra-ui/react";

// Custom components
import { HorizonLogo } from "components/icons/Icons";
import { HSeparator } from "components/separator/Separator";
// import Sobisco from 'assets/img/layout/sobisco_logo.png';
import NICL_Logo from 'assets/img/layout/nicl-titlelogo.png';
import zetlogo from "assets/img/layout/onecode_in_logo.jpeg"
import iccslogo from "assets/img/iccs-logo.jpeg"
// import OmkaraInfoTech from 'assets/img/layout/omkara.png';
import { ROLE_ACCESS } from '../../../utils/Utils';
let logolink = "https://media.licdn.com/dms/image/v2/C4D0BAQEg7dzRRy6n8A/company-logo_200_200/company-logo_200_200/0/1674996965434/the_policy_exchange_logo?e=2147483647&v=beta&t=eYqXslH21v8gDRw0dpmZi4H5MSjjCeQivcRBVzb9jk0"
export function SidebarBrand() {
  //   Chakra color mode
  let logoColor = useColorModeValue("navy.700", "white");
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  // const _role = state.userData.loginData.ROLE;
  const _role = ROLE_ACCESS.SOBISCO;

  return (
    <Flex align='center' direction='column'>
    <img style={{ width: '6em', height: '4.6em', marginBottom: "30px",marginTop:"-20px" }} src={zetlogo} />
     {/*} <img style={{ width: '4em', height: '1.8em', marginBottom: "30px",marginTop:"-35px" }} src={iccslogo} /> */}
      {/* <p style={{fontSize: '10px',marginBottom: '10px'}}>Omkara Infotech</p> */}
      {/* <HSeparator mb='20px' /> */}
      {/* <br></br> */}
    </Flex>
  );
}

export default SidebarBrand;
